import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({
  children,
  delay = 0,
  y = 14,
  duration = 0.55,
  once = true,
  className = "",
  as = "div",
}) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;

  if (reduce) {
    return <div className={className}>{children}</div>;
  }

  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-60px" }}
      transition={{ duration, delay, ease: [0.2, 0.8, 0.2, 1] }}
      className={className}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
